<div class="top">
  <button class="icon-btn" (click)="closeBottomSheet()">
    <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="assets/icons/x.svg"></svg-icon>
  </button>
  <ng-container i18n>Clear Dates</ng-container>
</div>
<div class="when-wrapper" #when>
  <div class="calendar-content">
    <div class="calendar">
      <div class="check-in-out" #checkInOut>
        <div class="check-in-out-inner">
          <div class="check-in-out-btn" (click)="toggleCheckInOut('in')">
            <div>Check in</div>
          </div>
          <div class="check-in-out-btn" (click)="toggleCheckInOut('out')">
            <div>Check out</div>
          </div>
          <div class="check-in-out-slider" [@toggleInOut]="checkInOutState">
            <div>Check {{ checkInOutState }}</div>
          </div>
        </div>
        <div class="days">
          <div>
            <span>S</span>
          </div>
          <div>
            <span>M</span>
          </div>
          <div>
            <span>T</span>
          </div>
          <div>
            <span>W</span>
          </div>
          <div>
            <span>T</span>
          </div>
          <div>
            <span>F</span>
          </div>
          <div>
            <span>S</span>
          </div>
        </div>
      </div>

      <!-- <div class="top"> -->
        <div class="calendar-from">
          <div class="month">
            <div class="title">
              {{ fromMonth | month }} {{ fromYear }}
            </div>
            <div class="dates">
              <ng-container *ngFor="let i of days;">
                <ng-container *ngIf="(i > fromStartDay!) && ((i - fromStartDay!) <= fromDays!); else empty">
                  <app-day
                  [attr.data-i]="i"
                  [noAvailability]="noAvailability"
                  [attr.data-date]="i | dayToDate : fromMonth : fromStartDay : fromYear"
                  (dayMouseenter)="highlight(i)"
                  (dayMouseleave)="unhighlight()"
                  (dayClick)="clicked(i, i - fromStartDay, true)"
                  [i]="i"
                  [dateValue]="(i | dayToDate : fromMonth : fromStartDay : fromYear)"
                  [anchorStart]="anchorStart"
                  [(anchorStartDate)]="anchorStartDate"
                  [anchorEnd]="anchorEnd"
                  [(anchorEndDate)]="anchorEndDate"
                  [(selecting)]="selecting"
                  [firstDayOfMonth]="fromStartDay"
                  [daysInMonth]="fromDays"
                  [toStartDay]="toStartDay"
                  [fromStartDay]="fromStartDay"
                  [monthOffset]="monthOffset"
                  [absoluteAnchorStart]="absoluteAnchorStart"
                  [absoluteAnchorEnd]="absoluteAnchorEnd"
                  [focus]="focus"
                  [month]="'from'"
                  [fromMonth]="fromMonth"
                  [toMonth]="toMonth"
                  [unavailableDates]="unavailableDates"
                    >
                    <span>{{ i - fromStartDay! }}</span>
                  </app-day>
                </ng-container>
                <ng-template #empty>
                  <div class="date date-empty">
                    <span></span>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>

<div class="fixed-test">
  <button class="btn btn-theme btn-large" [disabled]="!anchorStart || !anchorEnd" (click)="doUpdate()">
    <span>Done</span>
  </button>
</div>
